import {
  getRequest,
  patchRequest,
  postRequest,
} from "../../config/axiosConfig";

export const getAllEmployee = async ({
  appliedSearch = "",
  role_id,
  hospital_branch_id,
  page,
  limit,
} = {}) => {
  try {
    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + "management/get-all-employee",
      params: {
        search: appliedSearch || undefined,
        hospital_branch_id: hospital_branch_id || undefined,
        role_id: role_id || undefined,
        page: page || undefined,
        limit: limit || undefined,
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid get All Employee request.",
    };
  }
};

export const getEmployeeById = async ({ id }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "management/get-employee-by-id",
      data: {
        id,
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid get All Employee request.",
    };
  }
};

export const changeEmployeeStatus = async ({ id, isActive }) => {
  try {
    const response = await patchRequest({
      url: process.env.REACT_APP_BASE_URL + "management/toggle-employee-status",
      data: {
        employee_id: id,
        is_active: isActive
      },
    });

    if (response?.status === 200) {
      return {
        success: response?.status === 200,
        data: response,
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid get All Employee request.",
    };
  }
};
